import axios from 'axios';

export default {
	init(cardId) {
		return axios.get(`/apps/debitcard/api/debitcard/init?cardId=${cardId}`);
	},
	lookupBirthPlaces(query) {
		return axios.get(`/apps/debitcard/api/autosuggest/settlement?name=${encodeURIComponent(query)}`);
	},
	lookupSchools(query) {
		return axios.get(`/apps/debitcard/api/autosuggest/school?name=${encodeURIComponent(query)}`);
	},
	getSettlements(zipCode) {
		return axios.get(`/apps/debitcard/api/autosuggest/settlement/${zipCode}`);
	},
	getAddressDropdowns(data) {
		if (data.district) {
			return axios.get(`/apps/debitcard/api/autosuggest/branch?county=${data.county}&district=${data.district}`);
		} else {
			return axios.get(`/apps/debitcard/api/autosuggest/branch?county=${data.county}`);
		}
	},
	postForm(data) {
		return axios.post('/apps/debitcard/api/debitcard/submit', data);
	},
	finishClaim(sessionId) {
		return axios.put(`/apps/debitcard/api/debitcard/finalize/${sessionId}`);
	},
	postImageForm(data, sessionId, taEvent, textColor) {
		let form = new FormData();
		form.append('masked', data.masked);
		form.append('processed', data.cropped);
		form.append('original', data.original);
		form.append('taEvent', taEvent);
		form.append('textColor', textColor);
		return axios.post(`/apps/debitcard/api/image/upload/${sessionId}`, form);
	},
	postTaData(data) {
		return axios.put(`/apps/debitcard/api/ta/${data}`);
	},
	postTaVhkData(data) {
		return axios.post('/apps/debitcard/api/ta', data);
	}
};
